import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SubjectService {
    constructor() {}

    /** BugId# 9647  
     * Register subject 'refreshListScreen' for update list page any where
    */
    public refreshListScreen = new Subject<number>();
    

    /** BugId# 9647  
     * @param {number} count
     * pass count value in next()
    */
    setRefreshListScreen(count) {
        this.refreshListScreen.next(count);
    }
    private newFlowSource = new BehaviorSubject<boolean>(false);
    newFlow$ = this.newFlowSource.asObservable();
    
  notifyNewFlow(flag: boolean) {
    this.newFlowSource.next(flag);
  }
}